<template>
  <div class="row">
    <div class="col-md-10 pt-3" v-if="hasAnyRole('ROLE_ATMANAGE')">

      <toast ref="toast"></toast>

      <table class="table table-bordered table-responsive">
            <thead class="thead-light">
              <tr>
                  <th>No</th>
                  <th>会社名</th>
                  <th>ドメイン</th>
                  <th>登録日</th>
                  <th>契約期間</th>
                  <th>今月契約数</th>
                  <th>プラン</th>
                  <th>請求（とりあえず100円計算）</th>
                  <th>操作</th>
              </tr>
            </thead>
            <tbody>
              <tr v-for="(result, index) in companyList" :key="index">
                  <td>{{(pagination.currentPage * dispMaxSize) + index + 1}}</td>
                  <td class="noflap">
                     <span class="noflap">
                        <a :href="'/atmanage/company/report/' + result.uuid">
                          {{result.companyName}}
                        </a>
                     </span>
                  </td>
                  <td class="noflap">{{result.domain}}</td>
                  <td>{{result.createdAt | date}}</td>
                  <td>{{result.createdAt | between}}</td>
                  <td style="text-align:right;">{{result.report.userCount}}</td>
                  <td>{{result.report.plan == 0 ? 'ノーマル' : 'エラー'}}</td>
                  <td>{{result.report.userCount * 100 | yen }}円</td>
                  <td>
                    <button type="button" class="btn btn-info btn-sm" @click="clickLink(result.id)">
                        <i class="fas fa-cloud-download-alt fa-1x" aria-hidden="true"></i>
                        <a :id="'download_' + result.id" style="color: white;text-decoration: none;">従業員一覧</a>
                    </button>
                  </td>
              </tr>
            </tbody>
        </table>
    </div>
  </div>
</template>

<style scoped>
.noflap{
 white-space: nowrap;
}
.retiree{
  background: #ccc !important;
}
.icon {
  border-radius: 50%;
  height: 45px;
  width: 45px;
}
.modal {
  overflow-y: auto;
  max-height: 95%;
}
</style>

<script>
import CompanyAPI from '../../../api/company-api'
import CommonAPI from '../../../api/common-api'
import Toast from '../../Toast.vue'
import moment from 'moment'

export default {
  name: "company-list",
  components: {
    Toast,
  },
  data() {
    return {
      companyList: [],
      loginUser: {
        role: ''
      },
      dispMaxSize: 20,
      pagination: {
        // 現在ページ
        currentPage: 0,
        // 最大表示ページ件数
        dispMaxPageSize: 5,
        // トータルページ数
        totalPages: 0
      },
    }
  },
  watch: {
    '$root.$refs.asnHeader.$data.loginUser': function (val) {
      this.loginUser = this.$root.$refs.asnHeader.$data.loginUser
    },
  },
  mounted () {
    this.getCompanyList()
  },
  methods: {
    getCompanyList() {
      this.$root.$refs.loading.$data.show = true
      let params = {}
      params['pageSize'] = this.dispMaxSize
      params['pageNo'] = this.pagination.currentPage ? this.pagination.currentPage : 0
      CompanyAPI.list(params)
          .then(res => {
            if (res.content){
              this.pagination.totalPages = res.totalPages
              this.companyList = res.content             
            } else {
              this.pagination.totalPages = 0
              this.pagination.currentPage = 0
              this.companyList = []
            }
            this.$nextTick(function() {
                this.companyList.forEach(function(company){
                  this.download(company);
                }.bind(this))

                this.$root.$refs.loading.$data.show = false
            })
          })
          .catch(err => {
            console.error(err)
            this.$root.$refs.loading.$data.show = false
          })
    },
    // 削除
    deleteCompany (id) {
      if (window.confirm('削除してよろしいですか?')){
        if (window.confirm('[注意]ユーザ、休暇申請、交通費、勤怠など紐づくすべてのデータが削除されます。')){
          this.$root.$refs.loading.$data.show = true
          CompanyAPI.delete(id)
            .then(res => {
              this.getCompanyList()
              this.$refs.toast.showToast("削除しました", 3000, false)
            })
            .catch(err => {
              console.error(err)
              this.$root.$refs.loading.$data.show = false
            })
        }
      }
    },
    // ダウンロ-ド
    download(company) {
        var filename = '従業員一覧'
        var bom = new Uint8Array([0xEF, 0xBB, 0xBF]);
        var content = '名前,メールアドレス,入社日\r\n';

        company.userList.forEach(function(user){
          content += user.userName+','+
                     user.mail+','+
                     (user.hireDate ? user.hireDate : '')
                     + '\r\n'
        }.bind(this))

        var blob = new Blob([ bom, content ], { "type" : "text/csv" });
        if (window.navigator.msSaveBlob) { 
            window.navigator.msSaveBlob(blob, filename); 

            // msSaveOrOpenBlobの場合はファイルを保存せずに開ける
            window.navigator.msSaveOrOpenBlob(blob, filename); 
        } else {
            document.getElementById("download_" + company.id).href = window.URL.createObjectURL(blob);
            document.getElementById("download_" + company.id).download = filename;
        }
    },
    clickLink(id){
      $('#download_' + id)[0].click();
    },
    goNew () {
        this.$router.push('/admin/company/new')
    },
    goEdit (id) {
        this.$router.push('/admin/company/edit/' + id)
    },
    // 権限を持っているか判定
    hasAnyRole: function (...args) {
        for (var i = 0; i < arguments.length; i++) {
            if (this.loginUser && this.loginUser.role.includes(arguments[i])) {
                return true
            }
        }
        return false
    },
   },
  filters: {
    date: function (data) {
      return data ? moment(data).format("YYYY年MM月DD日") : ''
    },
    between: function (data) {
      return data ? moment().to(moment(data)) : ''
    },
    yen: function (data) {
      return data.toLocaleString()
    },
  }
}
</script>


// WEBPACK FOOTER //
// src/assets/js/components/atmanage/company/CompanyList.vue